import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	AcceptButton,
	DeclineButton,
	Description,
	Dialog,
	Overlay,
	Title,
} from './BlikOneOffFallbackModal.styles';

const BlikOneOffFallbackModal = ({ description, onAccept, onDecline }) => {
	const t = useLanguageData('chat');

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key === 'Escape') {
				onDecline();
			}
		};

		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [onDecline]);

	return createPortal(
		<Overlay onClick={onDecline}>
			<Dialog
				role='dialog'
				aria-modal='true'
				aria-labelledby='blikOneOffFallbackTitle'
				onClick={(event) => event.stopPropagation()}
			>
				<Title id='blikOneOffFallbackTitle'>
					{t.planCheckoutBlikFallbackTitle}
				</Title>
				<Description>{description}</Description>
				<AcceptButton type='button' onClick={onAccept} autoFocus>
					{t.planCheckoutBlikFallbackAccept}
				</AcceptButton>
				<DeclineButton type='button' onClick={onDecline}>
					{t.planCheckoutBlikFallbackDecline}
				</DeclineButton>
			</Dialog>
		</Overlay>,
		document.body,
	);
};

export default BlikOneOffFallbackModal;
